import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner, Label, Input, FormFeedback, FormGroup
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import Select from "react-select";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us"
import {contactResearchAssistant, recordActivity} from "../slices/register";
import useCheckMobileScreen from "../common/useCheckMobileScreen";
import ReactGA from "react-ga4";
import {trackGoogleConversion} from "../utils/googleAds";

const contactMethods = [
    {value: "email", label: "Email"},
    {value: "phone", label: "Phone"},
]
const Contact = (props) => {
    const mobile = useCheckMobileScreen()
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [screen, setScreen] = useState(1)
    const {
        createContactResearchAssistantError,
    } = useSelector(state => ({
        createContactResearchAssistantSuccess: state.register.createContactResearchAssistantSuccess,
        createContactResearchAssistantError: state.register.createContactResearchAssistantError
    }));
    const [selectedContactMethod, setSelectedContactMethod] = useState(contactMethods[0])


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            contact_method: 'email',
            consent: false,
        },
        initialTouched: {
            first_name: false,
            last_name: false
        },
        validateOnMount: true,
        validationSchema: Yup.object().shape({
            first_name: Yup.string().required("Please Enter First Name"),
            last_name: Yup.string().required("Please Enter Last Name"),
            contact_method: Yup.string().required("Please Enter Your Contact Method"),
            email: Yup.string().when(['contact_method'], {
                is: (contact_method) => {
                    return contact_method === "email"
                },
                then: Yup.string().required("Please Enter your Email")
            }),
            phone: Yup.string().when(['contact_method'], {
                is: (contact_method) => {
                    return contact_method === "phone"
                },
                then: Yup.string().required("Please Enter your Phone")
            }),
            consent: Yup.bool().oneOf([true], "Your consent is required"),
        }),
        onSubmit: (values) => {
            setLoading(true)
            let deviceId = sessionStorage.getItem('device') || undefined
            dispatch(contactResearchAssistant(deviceId, values, () => {
                ReactGA.event({
                    category: "Conversion",
                    action: "guided_enrollment_completed",
                    label: "Guided Enrollment Completed", // optional
                });
                trackGoogleConversion('guided_enrollment_completed');
                props.router.navigate('/contact-success')
                setLoading(false)
            }))
        }
    });

    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(recordActivity(deviceId, {
            action: "survey",
            page_id: "0-5"
        }))
    }, [dispatch, sessionStorage, recordActivity])

    document.title = "Guided Eligibility Survey";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5 justify-content-center">
                        <Col className="p-0" xl={8} md={10} sm={12}>
                            <div className="text-center mt-2">
                                <h3>{mobile ? "RA-" : ""}Guided Eligibility Survey</h3>
                            </div>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    {createContactResearchAssistantError && createContactResearchAssistantError ? (
                                        <Alert color="danger"> {createContactResearchAssistantError} </Alert>) : null}
                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between"
                                            }}>
                                                <div>
                                                    <p>Please complete the following information and a Research
                                                        Assistant will contact you in the next 24-48 hours, between the
                                                        hours of 8 am and 8 pm.</p>
                                                    <p>You must provide at least one method of contacting you.</p>
                                                    <br/>

                                                    <Row className={" justify-content-center"}>
                                                        <Col className="pr-5 pl-5 justify-content-center" xl={6} md={12}
                                                             sm={12}>
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="first_name" className="form-label">First Name:</Label>
                                                                <Input
                                                                    aria-label={"First Name"}
                                                                    disabled={loading ? true : false}
                                                                    name="first_name"
                                                                    className="form-control"
                                                                    placeholder="Enter First Name"
                                                                    type="text"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.first_name || ""}
                                                                    invalid={
                                                                        validation.touched.first_name && validation.errors.first_name ? true : false
                                                                    }
                                                                />
                                                                {validation.touched.first_name && validation.errors.first_name ? (
                                                                    <FormFeedback
                                                                        type="invalid">{validation.errors.first_name}</FormFeedback>
                                                                ) : null}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col className="pr-5 pl-5 justify-content-center" xl={6} md={12}
                                                             sm={12}>
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="name" className="form-label">Last Name:</Label>
                                                                <Input
                                                                    aria-label={"Last Name"}
                                                                    disabled={loading ? true : false}
                                                                    name="last_name"
                                                                    className="form-control"
                                                                    placeholder="Enter Last Name"
                                                                    type="text"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.last_name || ""}
                                                                    invalid={
                                                                        validation.touched.last_name && validation.errors.last_name ? true : false
                                                                    }
                                                                />
                                                                {validation.touched.last_name && validation.errors.last_name ? (
                                                                    <FormFeedback
                                                                        type="invalid">{validation.errors.last_name}</FormFeedback>
                                                                ) : null}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col className="pr-5 pl-5 justify-content-center" xl={6} md={12}
                                                             sm={12}>
                                                            <FormGroup
                                                                className="mb-3">
                                                                <Label
                                                                    htmlFor="validationTooltipCounty">Preferred method
                                                                    of
                                                                    contact:</Label>
                                                                <Select
                                                                    aria-label={"Preferred method of contact"}
                                                                    styles={{
                                                                        control: (styles) => ({
                                                                            ...styles,
                                                                            borderColor: '#5D59EB'
                                                                        }),
                                                                    }}
                                                                    isSearchable={false}
                                                                    value={selectedContactMethod}
                                                                    onChange={selectedOption => {
                                                                        setSelectedContactMethod(selectedOption);
                                                                        validation.setFieldValue("contact_method", selectedOption?.value)
                                                                    }}
                                                                    options={contactMethods}
                                                                    invalid={
                                                                        validation.touched.contact_method &&
                                                                        validation.errors.contact_method
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                {validation.touched.contact_method && validation.errors.contact_method ? (
                                                                    <FormFeedback
                                                                        type="invalid">
                                                                        {validation.errors.contact_method}
                                                                    </FormFeedback>
                                                                ) : null}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col className="pr-5 pl-5" xl={6} md={12} sm={12}>
                                                            {validation.values.contact_method === "email" ?
                                                                <FormGroup className="mb-3">
                                                                    <Label htmlFor="email"
                                                                           className="form-label">Email:</Label>
                                                                    <Input
                                                                        aria-label={"Email Address"}
                                                                        disabled={loading ? true : false}
                                                                        name="email"
                                                                        className="form-control"
                                                                        placeholder="Enter Email"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.email || ""}
                                                                        invalid={
                                                                            (validation.touched.contact_method) && validation.errors.email ? true : false
                                                                        }
                                                                    />
                                                                    {(validation.touched.contact_method) && validation.errors.email ? (
                                                                        <FormFeedback
                                                                            type="invalid">
                                                                            {validation.errors.email}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup> :
                                                                <FormGroup className="mb-3">
                                                                    <Label htmlFor="phone"
                                                                           className="form-label">Phone:</Label>
                                                                    <Cleave
                                                                        aria-label={"Phone Number"}
                                                                        className="form-control"
                                                                        id="validationTooltipPhone"
                                                                        name="phone"
                                                                        placeholder="xxxx xxx xxx"
                                                                        options={{
                                                                            phone: true,
                                                                            phoneRegionCode: "US",
                                                                            numericOnly: true
                                                                        }}
                                                                        inputmode="numeric"
                                                                        onChange={event => {
                                                                            validation.setFieldValue("phone", event.target.rawValue)
                                                                        }}
                                                                        value={validation.values.phone || ""}
                                                                        className="form-control"
                                                                    />
                                                                    {validation.errors.phone ? (
                                                                        <div className={"invalid-feedback"}
                                                                             style={{display: "block"}}>
                                                                            {validation.errors.phone}
                                                                        </div>
                                                                    ) : null}
                                                                </FormGroup>
                                                            }
                                                        </Col>
                                                        <Col className="pr-5 pl-5" xl={12} md={12} sm={12}>
                                                            <FormGroup
                                                                className="mb-3">
                                                                <Input
                                                                    aria-label={"I consent to being contacted by a Research Assistant."}
                                                                    id={"consent"}
                                                                    type="checkbox"
                                                                    checked={validation.values.consent}
                                                                    onChange={(e) => {
                                                                        validation.setFieldValue("consent", e.target.checked)
                                                                    }}
                                                                    invalid={
                                                                        validation.touched.consent && validation.errors.consent ? true : false
                                                                    }/>
                                                                <Label
                                                                    id={'label-consent'}
                                                                    for={"consent"}>I consent to being contacted by a
                                                                    Research Assistant.</Label>

                                                                {validation.touched.consent && validation.errors.consent ? (
                                                                    <FormFeedback
                                                                        type="invalid">{validation.errors.consent}</FormFeedback>
                                                                ) : null}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col className="pr-5 pl-5  justify-content-center" xl={6}
                                                             md={12} sm={12}>
                                                            <Row className="pt-5 justify-content-center">
                                                                <Col className="pr-5 pl-5 justify-content-center"
                                                                     sm={12}>
                                                                    <div className="mt-4">
                                                                        <Button
                                                                            aria-label={"Submit"}
                                                                            disabled={loading || !validation.isValid ? true : false}
                                                                            className="btn button-primary w-100"
                                                                            type="submit">
                                                                            Submit
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                                <Col className="pr-5 pl-5 justify-content-center"
                                                                     sm={12}>
                                                                    <div className="mt-4">
                                                                        <Button disabled={loading ? true : false}
                                                                                className="btn button-secondary w-100"
                                                                                type="button"
                                                                                onClick={() => props.router.navigate('/enrollment-type')}>
                                                                            Cancel
                                                                        </Button>
                                                                    </div>
                                                                </Col>

                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(Contact);
